/* A Leading Role - "Your Front Row" panel: points, value and time remaining.
 *
 * Members had no way to see any of this. The balance lives in the customer
 * metafield alr_member.points_balance, which the storefront cannot read, so
 * this asks the Worker instead. The Worker takes the customer id only from the
 * signed App Proxy URL, so a shopper can only ever see their own numbers.
 *
 * Shows on the Front Row page and the membership product page, above the rest
 * of the content. Non-members and signed-out visitors see nothing at all - the
 * selling copy already on those pages is what they should be reading.
 *
 * Additive: a new asset plus one script tag. Nothing in alr.js or the page
 * templates is touched. Built with DOM calls rather than innerHTML.
 *
 * Colour: the panel sits on the same deep maroon as .fr-card, which is the one
 * ground where the gold is readable. Nothing gold appears on cream here.
 */
(function () {
  var ENDPOINT = '/apps/concierge/membership/status';
  var CART_GET = '/cart.js';
  var CART_SET = '/cart/update.js';
  var ATTR = '_alr_points';
  var PATHS = ['/pages/front-row', '/products/front-row-membership'];

  var CREAM = '#FBF7F0';
  var GOLD = '#E3BE45';
  var GOLD_DIM = 'rgba(227,190,69,.28)';
  var SOFT = '#D9C6C9';

  function onRelevantPage() {
    var p = window.location.pathname.replace(/\/+$/, '').toLowerCase();
    for (var i = 0; i < PATHS.length; i++) {
      if (p === PATHS[i] || p.indexOf(PATHS[i] + '/') === 0) return true;
    }
    return false;
  }

  function money(cents) {
    var v = (Number(cents || 0) / 100).toFixed(2);
    return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n) {
    return String(Number(n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function longDate(iso) {
    try {
      return new Date(iso).toLocaleDateString(undefined, {
        year: 'numeric', month: 'long', day: 'numeric',
      });
    } catch (err) {
      return '';
    }
  }

  function clamp(n) {
    return Math.max(0, Math.min(100, n));
  }

  function styles() {
    if (document.getElementById('fr-pts-style')) return;
    var s = document.createElement('style');
    s.id = 'fr-pts-style';
    s.textContent = [
      '.frp{max-width:900px;margin:32px auto 0;padding:0 16px;font-family:Georgia,serif}',
      '.frp-card{background:linear-gradient(165deg,#5B1220,#3E0C16);color:' + CREAM + ';border-radius:4px;padding:30px 32px 28px}',
      '.frp-rule{display:flex;align-items:center;justify-content:center;gap:12px;margin-bottom:16px}',
      '.frp-rule span{height:1px;width:58px;background:' + GOLD + ';opacity:.75}',
      '.frp-rule b{color:' + GOLD + ';font-size:11px;letter-spacing:.2em;text-transform:uppercase;font-weight:400}',
      '.frp-status{text-align:center;font-size:13.5px;line-height:1.6;color:' + SOFT + ';margin:0 0 22px}',
      '.frp-status i{font-style:normal;color:' + CREAM + '}',
      '.frp-figs{display:flex;flex-wrap:wrap;gap:18px;justify-content:center;margin-bottom:22px}',
      '.frp-fig{flex:1 1 180px;text-align:center}',
      '.frp-fig .v{display:block;font-size:clamp(28px,5vw,40px);line-height:1.1;color:' + GOLD + '}',
      '.frp-fig .k{display:block;margin-top:5px;font-size:10.5px;letter-spacing:.17em;text-transform:uppercase;color:' + SOFT + '}',
      '.frp-bar{margin-top:18px}',
      '.frp-bar .lab{display:flex;justify-content:space-between;gap:12px;font-size:12px;color:' + SOFT + ';margin-bottom:7px}',
      '.frp-bar .lab i{font-style:normal;color:' + CREAM + '}',
      '.frp-track{height:7px;border-radius:99px;background:' + GOLD_DIM + ';overflow:hidden}',
      '.frp-fill{height:100%;border-radius:99px;background:' + GOLD + ';width:0;transition:width .7s ease}',
      '.frp-note{margin:20px 0 0;text-align:center;font-size:12px;line-height:1.6;color:' + SOFT + '}',
      '.frp-redeem{margin-top:22px;text-align:center}',
      '.frp-btn{appearance:none;border:1px solid ' + GOLD + ';background:' + GOLD + ';color:#3E0C16;',
      'font:inherit;font-size:12px;letter-spacing:.13em;text-transform:uppercase;padding:13px 28px;',
      'border-radius:3px;cursor:pointer;transition:.16s}',
      '.frp-btn:hover:not(:disabled){background:#F0CE5C;border-color:#F0CE5C}',
      '.frp-btn:disabled{opacity:.55;cursor:default}',
      '.frp-code{margin-top:16px;padding:15px 16px;border:1px dashed ' + GOLD + ';border-radius:4px;background:rgba(227,190,69,.08)}',
      '.frp-code b{display:block;font-size:22px;letter-spacing:.16em;color:' + GOLD + ';font-weight:400}',
      '.frp-code span{display:block;margin-top:7px;font-size:11.5px;line-height:1.55;color:' + SOFT + '}',
      '.frp-code a{display:inline-block;margin-top:11px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:' + CREAM + '}',
      '.frp-undo{display:block;margin:10px auto 0;font-family:inherit;font-size:10.5px;letter-spacing:.1em;',
      'text-transform:uppercase;color:' + SOFT + ';background:none;border:0;cursor:pointer;text-decoration:underline}',
      '.frp-err{margin-top:12px;font-size:12px;line-height:1.5;color:#F3B0B0}',
      '@media (max-width:520px){.frp-card{padding:24px 20px 22px}.frp-figs{gap:12px}}'
    ].join('');
    document.head.appendChild(s);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function fig(value, label) {
    var f = el('div', 'frp-fig');
    f.appendChild(el('span', 'v', value));
    f.appendChild(el('span', 'k', label));
    return f;
  }

  // label left, value right, then a track that animates to pct on insert.
  function bar(leftText, rightText, pct) {
    var wrap = el('div', 'frp-bar');
    var lab = el('div', 'lab');
    lab.appendChild(el('span', null, leftText));
    var right = el('i');
    right.textContent = rightText;
    lab.appendChild(right);
    wrap.appendChild(lab);

    var track = el('div', 'frp-track');
    var fill = el('div', 'frp-fill');
    track.appendChild(fill);
    wrap.appendChild(track);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { fill.style.width = clamp(pct) + '%'; });
    });
    return wrap;
  }

  function build(d) {
    styles();

    var wrap = el('div', 'frp');
    var card = el('div', 'frp-card');

    var rule = el('div', 'frp-rule');
    rule.appendChild(el('span'));
    var b = el('b', null, 'Your Front Row');
    rule.appendChild(b);
    rule.appendChild(el('span'));
    card.appendChild(rule);

    // Status line. A cancelled member still has every perk until renews_at,
    // so say that plainly rather than calling them cancelled and nothing else.
    var status = el('p', 'frp-status');
    var paidThrough = d.renewsAt ? longDate(d.renewsAt) : '';
    if (d.status === 'cancelled') {
      status.appendChild(document.createTextNode('Not renewing — every perk is yours through '));
      status.appendChild(el('i', null, paidThrough));
    } else {
      status.appendChild(document.createTextNode('Active — paid through '));
      status.appendChild(el('i', null, paidThrough));
    }
    card.appendChild(status);

    var figs = el('div', 'frp-figs');
    figs.appendChild(fig(num(d.points), 'Points'));
    figs.appendChild(fig(money(d.pointsValueCents), 'Worth'));
    figs.appendChild(fig(money(d.redeemableValueCents), 'Ready to use'));
    card.appendChild(figs);

    // Points bar. Below the floor the milestone that matters is the floor
    // itself; above it, the next whole dollar.
    var floor = Number(d.minRedeemPoints || 500);
    var step = Number(d.redeemStepPoints || 100);
    var pct = d.points < floor
      ? (d.points / floor) * 100
      : ((d.points % step) / step) * 100;

    var rightLabel = d.pointsToNext > 0
      ? num(d.pointsToNext) + ' to go'
      : 'Ready';
    var leftLabel = d.points < floor
      ? 'Toward your first ' + money(floor * (d.centsPerPoint || 1))
      : 'Toward your next ' + money(step * (d.centsPerPoint || 1));
    card.appendChild(bar(leftLabel, rightLabel, pct));

    // Membership year. Measured back from the paid-through date so it stays
    // right after a renewal, when `since` is the original join date.
    if (d.renewsAt) {
      var end = new Date(d.renewsAt).getTime();
      var start = new Date(d.renewsAt);
      start.setUTCFullYear(start.getUTCFullYear() - 1);
      var s = start.getTime();
      var now = Date.now();
      var span = end - s;
      if (span > 0) {
        var days = Math.max(0, Math.ceil((end - now) / 86400000));
        card.appendChild(
          bar('Your membership year', days + (days === 1 ? ' day left' : ' days left'),
              ((now - s) / span) * 100)
        );
      }
    }

    var note = el('p', 'frp-note');
    note.textContent =
      'You earn ' + (d.memberEarnRate || 10) + ' points for every $1 you spend. ' +
      num(floor) + ' points is the smallest amount you can put toward an order, and ' +
      'points come off in whole dollars. They are only spent when an order is paid.';
    card.appendChild(note);

    if (d.redeemablePoints > 0) card.appendChild(redeemer(d));

    wrap.appendChild(card);
    return wrap;
  }

  // Turning points into money off.
  //
  // This writes a cart attribute and nothing else. A Shopify Function reads
  // that attribute, checks it against the real balance on the customer record,
  // and applies an automatic order discount - which means the saving shows up
  // in the bag straight away, with no code to copy anywhere.
  //
  // The points do NOT leave the balance here. They come off in the orders/paid
  // webhook, when there is an actual paid order. Change your mind, empty the
  // bag, never come back - it costs you nothing.
  function redeemer(d) {
    var box = el('div', 'frp-redeem');
    var label = 'Use ' + money(d.redeemableValueCents) + ' on this order';

    var btn = el('button', 'frp-btn', label);
    btn.setAttribute('type', 'button');
    box.appendChild(btn);

    function fail(msg) {
      btn.disabled = false;
      btn.textContent = label;
      var old = box.querySelector('.frp-err');
      if (old) old.parentNode.removeChild(old);
      box.appendChild(el('p', 'frp-err', msg || 'That did not work. Please try again.'));
    }

    function applied(on) {
      box.innerHTML = '';
      if (!on) {
        box.appendChild(btn);
        btn.disabled = false;
        btn.textContent = label;
        return;
      }
      var card = el('div', 'frp-code');
      card.appendChild(el('b', null, money(d.redeemableValueCents) + ' off'));
      card.appendChild(el(
        'span',
        null,
        'Waiting in your bag. It comes off the subtotal as soon as there is ' +
        'something to take it off, and your points are only spent when the ' +
        'order is paid.'
      ));
      var bag = el('a', null, 'Go to my bag');
      bag.setAttribute('href', '/cart');
      card.appendChild(bag);

      var undo = el('button', 'frp-undo', 'Not this time');
      undo.setAttribute('type', 'button');
      undo.addEventListener('click', function () {
        undo.disabled = true;
        setAttr(0, function (ok) {
          if (ok) applied(false);
          else undo.disabled = false;
        });
      });
      card.appendChild(undo);

      box.appendChild(card);
    }

    function setAttr(points, done) {
      var attrs = {};
      attrs[ATTR] = points > 0 ? String(points) : '';
      fetch(CART_SET, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      })
        .then(function (r) { done(r.ok); })
        .catch(function () { done(false); });
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'One moment…';
      setAttr(d.redeemablePoints, function (ok) {
        if (ok) applied(true);
        else fail();
      });
    });

    // Reflect what the bag already says, so reloading does not offer to apply
    // points that are sitting there applied.
    fetch(CART_GET, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var v = cart && cart.attributes ? cart.attributes[ATTR] : '';
        if (Number(v) > 0) applied(true);
      })
      .catch(function () {});

    return box;
  }

  function mount(node) {
    var main = document.getElementById('MainContent');
    if (!main || document.querySelector('.frp')) return;
    main.insertBefore(node, main.firstChild);
  }

  function start() {
    if (!onRelevantPage()) return;

    fetch(ENDPOINT, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.signedIn || !d.member) return;
        mount(build(d));
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
